module.exports = __webpack_public_path__ + "img/myTeam.f8275296.png";